import { cn } from '../../utils'
import './Spinner.css'
import { forwardRef } from 'react'

type Props = {
  className?: string
  size?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9'
  color?: string
}

const sizeClasses = {
  '1': 'h-3 w-3',
  '2': 'h-4 w-4',
  '3': 'h-5 w-5',
  '4': 'h-6 w-6',
  '5': 'h-8 w-8',
  '6': 'h-10 w-10',
  '7': 'h-12 w-12',
  '8': 'h-14 w-14',
  '9': 'h-16 w-16',
}

export const Spinner = forwardRef<HTMLDivElement, Props>(({ className, size = '9', color }, ref) => (
  <div className={cn(sizeClasses[size], className)} ref={ref}>
    <svg className={cn('container h-full w-full')} viewBox="0 0 40 40" height="40" width="40">
      <title>loading...</title>
      <circle
        className="track"
        cx="20"
        cy="20"
        r="17.5"
        pathLength="100"
        strokeWidth="3px"
        fill="none"
        style={{ '--uib-color': color } as React.CSSProperties}
      />
      <circle
        className="car"
        cx="20"
        cy="20"
        r="17.5"
        pathLength="100"
        strokeWidth="3px"
        fill="none"
        style={{ '--uib-color': color } as React.CSSProperties}
      />
    </svg>
  </div>
))

Spinner.displayName = 'Spinner'
